import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

import axios from 'axios'
import querystring from 'querystring'

import {
    userLogin,
    userLogout,
    setPriceTier
} from '../../modules/user'

import $ from 'jquery'


class Login extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            login_error: false
        };
    }

    submitFormOnKeyDownEnter(event){

        if(event.keyCode === 13){
            this.login();
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    checkIfAlreadyLoggedIn(){
        if(this.props.user.user !== null){
            const { history } = this.props;
            history.push('/ProductType');
        }
    }

    componentWillReceiveProps(nextProps) {
        this.checkIfAlreadyLoggedIn();
    }

    login() {

        const _this = this;
        const { history } = this.props;

        $('#loginForm').submit(function(event){event.preventDefault();});

        axios.post(_this.props.config.api_path+'login', querystring.stringify({
            username: this.state.username,
            password: this.state.password,
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {

            if(response.data.success){
                _this.setState({
                    login_error: false
                });

                _this.props.userLogin({
                    user: response.data.user,
                    currency: response.data.user.default_currency
                });
                //SET PRICE TIER:
                axios({
                    method: 'get',
                    url: _this.props.config.api_path+'getSessionPriceTier'
                })
                .then(function (response) {

                    _this.props.setPriceTier({
                        price_tier: response.data.price_tier,
                        price_tier_multiplier: response.data.price_tier_multiplier,
                        price_tier_multiplier_dragonfly: response.data.price_tier_multiplier_dragonfly
                    });
                    //history.push('/ProductType');

                    window.location.href = "/ProductType";
                })
                .catch(function (error) {
                    console.log(error)
                });

            }else {
                _this.setState({
                    login_error: true
                });
                _this.props.userLogout();
            }
        })
        .catch(function (error) {
            console.log(error);
        });

    }

    startWithoutLogin(){
        const { history } = this.props;
        history.push('/ProductType');
    }

    render() {

        return (
            <div className="login">
                <div className="login-container">
                    <div className="logo"><img src="/assets/img/logo-big-whiteongreen.svg" alt="logo"/></div>
                    <h1 className="login-hone"><b>optical</b>CON Configurator</h1>

                    <div className="no-login-form">
                        <button type="button" className="login-button" onClick={() => this.startWithoutLogin()}>Login without registration »</button>
                        <p className="annotation"><b>Note:</b> If you wish to register and obtain login details, please contact a Neutrik sales representative.</p>
                    </div>

                    <div className="login-form">
                        <h2>Partner Login</h2>
                        <form id="loginForm">
                            <p>Your e-mail:</p>
                            <input type="text" id="username" name="username" value={this.state.username} onChange={(e) => this.handleInputChange(e)} onKeyDown={(e) => this.submitFormOnKeyDownEnter(e)} />
                            <p>Your password:</p>
                            <input type="password" id="password" name="password" value={this.state.password} onChange={(e) => this.handleInputChange(e)} onKeyDown={(e) => this.submitFormOnKeyDownEnter(e)}/>
                            <p className="annotation">
                                <b>Note:</b> If you have lost your login details, please contact your Neutrik sales representative.
                            </p>
                            <button className="login-button" type="submit" onClick={() => this.login()}>Log in »</button>

                            {this.state.login_error === true &&
                            <p className="annotation error flash">Wrong Username or Password!</p>
                            }
                        </form>
                    </div>
                    <div className="privacy-footer">
                    <a href="https://www.neutrik.com/en/legal-notice">Legal Notice</a> | <a href="https://www.neutrik.com/en/dataprotection">Data Protection</a>
                    </div>
                </div>
                <div className="nologin-container">

                </div>
            </div>
        );

    }
}

Login = withRouter(Login);

const mapStateToProps = state => ({
    config: state.config,
    user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
    userLogin,
    setPriceTier,
    userLogout
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/Login/index.js